import { render, staticRenderFns } from "./Specialist.vue?vue&type=template&id=6b2b1fcf&scoped=true&"
import script from "./Specialist.vue?vue&type=script&lang=js&"
export * from "./Specialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b1fcf",
  null
  
)

export default component.exports